import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const aedProductLocaleModule: LocaleModule = {
  name: "aedProduct",
  messages: { en: en, it: it },
};
